module.exports = __webpack_public_path__ + "img/IMG_9343-removebg-preview (2).png";